import { getData } from "./data";
import React, { useContext } from "react";
import * as S from "./style";
import Image from '../../../../app/js/components/loggedout/common/Image';
import KidSafe from "~images/loggedout/home/kidsafe.png";
import { Link } from "react-router-dom";
import { whiteLilac } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import Routes from '../../routes/routes';
import { SemContext } from "../../context/SemContext";

const Testimonial = ({trackPromoPageEvents}) => {
  const data = getData();
  const { state } = useContext(SemContext);
  const cta_text = (state.settings && state.settings.button_text) || "Try for free";

  return (
    <S.Wrapper>
      <S.InfoContainer>
        <S.ImageWrapper>
          <Image src={KidSafe} />
        </S.ImageWrapper>
        <S.ContentTitle>Trusted By 40 million families</S.ContentTitle>
      </S.InfoContainer>
      <S.ContentWrapper>
        {
          data && data.map((item, idx) => {
            return (
              <S.InfoWrapper key={idx}>
                <S.InfoTitle>
                  {item.title}
                </S.InfoTitle>
                <S.InfoItem>
                  <S.InfoIcon>
                    <Image src={item.image} isCdnImage={item.isCdnImage} />
                  </S.InfoIcon>
                  <S.InfoDetails>
                    <S.InfoName>{item.name}</S.InfoName>
                    <S.InfoDesignation>{item.designation}</S.InfoDesignation>
                  </S.InfoDetails>
                </S.InfoItem>
              </S.InfoWrapper>
            )
          })
        }
      </S.ContentWrapper>
      <S.ButtonWrapper>
        <S.CTAOfferButton hoverColor={whiteLilac}>
          <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", {'clicked_on': 'CTA2' }, true)}>
            {cta_text}
          </Link>
        </S.CTAOfferButton>
      </S.ButtonWrapper>
    </S.Wrapper>
  )
}

export default Testimonial;